export enum StocksProfileEnum {
    All = 0x00000000,
    NT8R = 0x00000001,
    NT16R = 0x00000002,
    NT8R1B = 0x00000004,
    NT3R1B = 0x00000008,
    NT12R = 0x00000010,
    NT1B = 0x00000020,
    NT4R1B = 0x00000040,
    NT2R1B = 0x00000080,
    NT5R1B = 0x00000080,
    NT1R1B = 0x00000100,
}
